export class MergeBeneficiarySearchDto {
  constructor(
    public readonly id: number,
    public readonly lastName: string,
    public readonly firstName: string,
    public readonly birthDate: Date,
  ) {}
  public static fromJson(json: any): MergeBeneficiarySearchDto {
    if (json) {
      return new MergeBeneficiarySearchDto(json.id, json.lastname, json.firstname, json.birthDate);
    }
  }
}
